import {
    // Common European languages
    eng, deu, fra, spa, ita, nld, por, rus, swe, nob, fin, dan, hun, tur,
    // Additional European languages
    pol, ces, slk, slv, hrv, bul, ron, ell, est, lav, lit, gle, eus, cat, glg,
    // Asian languages
    zho, jpn, kor, hin, ben, urd, ara, fas, tha, vie, ind, msa, tgl,
    // African languages
    afr, swa, som, hau, yor, zul,
    // Other languages
    heb, ukr, hye, bre, epo, lat, guj, mar, mya, kur
} from 'stopword';

// Language code mapping for stopword library (ISO-639-3 codes for v3.x)
// Covers 62 languages supported by the stopword library - same as backend
const STOPWORD_LANG_MAP = {
    // Common European languages (2-char to 3-char ISO mapping)
    'en': eng,    // English
    'de': deu,    // German
    'fr': fra,    // French
    'es': spa,    // Spanish
    'it': ita,    // Italian
    'nl': nld,    // Dutch
    'pt': por,    // Portuguese
    'ru': rus,    // Russian
    'sv': swe,    // Swedish
    'no': nob,    // Norwegian Bokmål
    'fi': fin,    // Finnish
    'da': dan,    // Danish
    'hu': hun,    // Hungarian
    'tr': tur,    // Turkish

    // Additional European languages
    'pl': pol,    // Polish
    'cs': ces,    // Czech
    'sk': slk,    // Slovak
    'sl': slv,    // Slovenian
    'hr': hrv,    // Croatian
    'bg': bul,    // Bulgarian
    'ro': ron,    // Romanian
    'el': ell,    // Greek
    'et': est,    // Estonian
    'lv': lav,    // Latvian
    'lt': lit,    // Lithuanian
    'ga': gle,    // Irish
    'eu': eus,    // Basque
    'ca': cat,    // Catalan
    'gl': glg,    // Galician
    'uk': ukr,    // Ukrainian
    'hy': hye,    // Armenian
    'br': bre,    // Breton
    'eo': epo,    // Esperanto
    'la': lat,    // Latin

    // Asian languages
    'zh': zho,    // Chinese
    'ja': jpn,    // Japanese
    'ko': kor,    // Korean
    'hi': hin,    // Hindi
    'bn': ben,    // Bengali
    'ur': urd,    // Urdu
    'ar': ara,    // Arabic
    'fa': fas,    // Persian/Farsi
    'th': tha,    // Thai
    'vi': vie,    // Vietnamese
    'id': ind,    // Indonesian
    'ms': msa,    // Malay
    'tl': tgl,    // Tagalog/Filipino
    'gu': guj,    // Gujarati
    'mr': mar,    // Marathi
    'my': mya,    // Myanmar (Burmese)
    'ku': kur,    // Kurdish
    'he': heb,    // Hebrew

    // African languages
    'af': afr,    // Afrikaans
    'sw': swa,    // Swahili
    'so': som,    // Somali
    'ha': hau,    // Hausa
    'yo': yor,    // Yoruba
    'zu': zul     // Zulu
};

// Create complete stopword sets for each language - computed once at startup
const COMPLETE_STOPWORD_SETS = {};

// Global stopword set for ultra-fast O(1) lookups across all languages
const GLOBAL_STOPWORD_SET = new Set();

// Build language-specific and global stopword collections
for (const [langCode, stopwordArray] of Object.entries(STOPWORD_LANG_MAP)) {
    const baseStopwords = new Set(stopwordArray);

    // Add base stopwords to global set
    for (const word of stopwordArray) {
        GLOBAL_STOPWORD_SET.add(word.toLowerCase());
    }

    // Store as Set for clustering service
    COMPLETE_STOPWORD_SETS[langCode] = baseStopwords;
}

/**
 * Get stopwords for a specific language
 * @param {string} languageCode - Language code (e.g., 'en', 'sk', 'cs')
 * @returns {Set} Set of stopwords for the language
 */
export function getStopwords(languageCode) {
    return COMPLETE_STOPWORD_SETS[languageCode] || GLOBAL_STOPWORD_SET;
}

/**
 * Check if a word is a stopword in any language
 * @param {string} word - Word to check
 * @returns {boolean} True if word is a stopword
 */
export function isStopword(word) {
    return GLOBAL_STOPWORD_SET.has(word.toLowerCase());
}

// Export both new and legacy formats for compatibility
export { COMPLETE_STOPWORD_SETS, GLOBAL_STOPWORD_SET };
